var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.currentUser.role === 'S')?_c('UpdateNewUI'):_c('Update')}
var staticRenderFns = []

export { render, staticRenderFns }